import React from 'react'
import Accordions from "../../../components/Accordions";

const Sem3CSECS1 = () => {
  const data = [
    {
      subjectName: "2025 Batch",
      units: [ ],
      links: [
        {
          url: "https://www.sonatech.ac.in/academics/syllabus/B.E-B.Tech/2025-Batch/SCE-1-3-Sem-Curriculum-Syllabus.pdf",
          title: "Syllabus",
        },
      ],
    },
    ];
  return (
    <div className="min-h-screen pt-12 m-auto w-[90%]">
      <h1 className="text-xl font-semibold flex justify-center">CSECS Sem - 3</h1>
      <Accordions data={data} />
    </div>
  );
};

export default Sem3CSECS1